import { Col, Form, FormInstance, Row, Select } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";
import { IOption } from "../../../../types/Option";
import dayjs from "dayjs";

type OptionSelectProps = {
  form: FormInstance;
  selectedOption: number;
  setSelectedOption: React.Dispatch<React.SetStateAction<number>>;
};

export const OptionSelect = ({
  form,
  selectedOption,
  setSelectedOption,
}: OptionSelectProps) => {
  const selectedDate = Form.useWatch("scheduledDate", form);

  const [options, setOptions] = useState<IOption[]>([]);

  useEffect(() => {
    setOptions([
      {
        value: 1,
        label: "Do not repeat",
      },
      {
        value: 2,
        label: `Repeat yearly on ${dayjs(selectedDate).format("MMM D")}`,
      },
    ]);
  }, [selectedDate]);

  const onChange = useCallback(
    (value: number) => setSelectedOption(value),
    [setSelectedOption]
  );

  return (
    <Row className="align-center w-100">
      <Col flex="22px">
        <SyncOutlined className="mr-2" />
      </Col>
      <Col flex="auto">
        <Form.Item label="" name="frequencyType" className="mb-0">
          <Select
            className="w-100"
            options={options}
            value={selectedOption}
            onChange={onChange}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};
